import { useState, useEffect } from 'react'

const RTL_CHAR_REGEX = /\p{Script=Hebrew}|\p{Script=Arabic}/u

type Direction = 'ltr' | 'rtl'

export function useTextDirection(value: string): Direction {
  const [direction, setDirection] = useState<Direction>('ltr')

  useEffect(() => {
    if (RTL_CHAR_REGEX.test(value)) {
      setDirection('rtl')
    } else {
      setDirection('ltr')
    }
  }, [value])

  return direction
}
